import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { productShortName } from '../data/offer';
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const show = window.setTimeout(() => setVisible(true), 5000);
    const hide = window.setTimeout(() => setVisible(false), 15000);
    return () => {
      window.clearTimeout(show);
      window.clearTimeout(hide);
    };
  }, []);
  return <AnimatePresence data-id="element-209" data-mp="21ydbohrq2ixm">
      {visible && <motion.aside initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 14
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-4 right-4 z-50 w-[calc(100%-2rem)] max-w-sm rounded-lg border border-stone-200 border-l-4 border-l-amber-500 bg-white p-4 pr-10 text-stone-900 shadow-2xl shadow-stone-700/20" aria-live="polite" data-id="element-210" data-mp="1wxxvlig22xby">
          <button type="button" onClick={() => setVisible(false)} className="absolute right-2 top-2 rounded p-1 text-stone-600 transition-colors duration-150 ease-out hover:text-green-950 focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-400" aria-label="Dismiss notice" data-id="element-211" data-mp="1sdtgfeu1tcsz">
            <XIcon className="h-4 w-4" data-id="element-212" data-mp="19p4z12urxply" />
          </button>
          <div className="flex gap-3" data-id="element-213" data-mp="19nlhza1anaj4">
            <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-green-700" aria-hidden="true" data-id="element-214" data-mp="1egembwsuoguo" />
            <div data-id="element-215" data-mp="zs0et8kho47s">
              <p className="text-[10px] font-extrabold uppercase tracking-[.16em] text-stone-500" data-id="element-216" data-mp="zsjxwslvkyne">Access confirmed</p>
              <p className="mt-1 text-sm leading-snug text-stone-600" data-id="element-217" data-mp="14qlglcfe2vyc">
                Once your purchase is complete you receive the
                <br data-id="element-218" data-mp="vpdqhhn111fc" />
                <span className="font-bold text-green-950" data-id="element-219" data-mp="vpwzu9ym2hhr">{productShortName}</span>
              </p>
              <p className="mt-2 text-xs text-stone-600" data-id="element-220" data-mp="2xf2xr88f9xlp">Instant digital access by email</p>
            </div>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}